import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    CreateMeetLinkParams,
    failureCreateMeetLink,
    successCreateMeetLink,
} from "./CreateMeetLinkSlice";

// API call to generate a meeting link
const CreateMeetLinkApi = (params: CreateMeetLinkParams) => {
    const queryParams = new URLSearchParams();
    if (params.meeting_title) queryParams.append("meeting_title", params.meeting_title);
    if (params.duration_minutes !== undefined) queryParams.append("duration_minutes", params.duration_minutes.toString());
    if (params.start_date) queryParams.append("start_date", params.start_date);
    if (params.start_time) queryParams.append("start_time", params.start_time);
    if (params.end_date) queryParams.append("end_date", params.end_date);
    if (params.end_time) queryParams.append("end_time", params.end_time);
    if (params.is_recurring !== undefined) queryParams.append("is_recurring", params.is_recurring.toString());
    if (params.recurrence_frequency) queryParams.append("recurrence_frequency", params.recurrence_frequency);
    if (params.recurrence_count !== undefined) queryParams.append("recurrence_count", params.recurrence_count.toString());
    if (params.recurrence_interval !== undefined) queryParams.append("recurrence_interval", params.recurrence_interval.toString());
    if (params.timezone_str) queryParams.append("timezone_str", params.timezone_str);

    return api.post(`/api/schedule-class/create-valid-meet-link?${queryParams.toString()}`);
};

// Saga to handle generating meeting link
export function* CreateMeetLinkCall(action: PayloadAction<CreateMeetLinkParams>) {
    try {
        const response: AxiosResponse = yield call(CreateMeetLinkApi, action.payload);
        yield put(successCreateMeetLink(response.data));
    } catch (error: any) {
        yield put(failureCreateMeetLink(error.response?.data || error.message));
    }
}
